import { useState } from 'react'
import SaveStateModal from 'features/RiskManagement/QRA/Components/SaveStateModal'

const QRASaveStateButton = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  return (
    <div>
      <button
        className={[
          'px-4 py-2',
          'rounded border border-lighthouseBlue',
          'text-lighthouseBlue',
          'font-medium'
        ].join(' ')}
        onClick={() => setIsModalOpen(true)}
      >
        SAVE STATE
      </button>
      <SaveStateModal
        isModalOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
      />
    </div>
  )
}

export default QRASaveStateButton
